export const MAX_TICKETS_GLOBAL = 31;

export const GIFT_CARD_PATH = "gift-card";
export const GIFT_CARD_PATHS = new Set(["gift-card", "giftcard", "gavekort"]);
export const SHOPIFY_PRODUCT_GID_PREFIX = "gid://shopify/Product/";

export const REQUIRED_TICKETS_CONDITION = {
  ALL: "all",
  ANY: "any",
};

export const AGE_VALUES = {
  KID: "3-5",
  YOUTH: "6-17",
  ADULT: "18+",
};

export const age = [
  { name: "Adult", value: AGE_VALUES.ADULT },
  { name: "Youth", value: AGE_VALUES.YOUTH },
  { name: "Kid", value: AGE_VALUES.KID },
];
